export default {
  CHECK_USER_LOGIN: "CHECK_USER_LOGIN",
  CHECK_USER_LOGIN_FAILED: "CHECK_USER_LOGIN_FAILED",
  CHECK_USER_LOGIN_SUCCESS: "CHECK_USER_LOGIN_SUCCESS",

  USER_DO_LOGOUT: "USER_DO_LOGOUT",
};
